/* eslint-disable eqeqeq */
import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import {
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../../../config";

const ExpandConditions = ({ expandData }) => {
  const expandDataGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: expandData[i]?.id,
        sections: expandData[i]?.section_obj && expandData[i]?.section_obj?.length > 0
          ?  expandData[i]?.section_obj.map(item => item.title).join(", ")
          : "-",
        operator: expandData[i]?.operator ? expandData[i]?.operator : "",
        value: expandData[i]?.total
          ? expandData[i]?.total
          : expandData[i]?.operator === "Between"
          ? `${expandData[i]?.min} ~ ${expandData[i]?.max}`
          : "",
      });
    }
    return items;
  };

  const subExapndData = expandDataGenerator(expandData?.length);

  const columns = [
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "sections",
      text: "Sections",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "operator",
      text: "Operator",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "value",
      text: "Value",
    },
  ];

  return (
    <>
      <div className="custom-table p-2">
        <div className={"table-body-class"}>
          <BootstrapTable
            keyField="key"
            remote
            data={subExapndData}
            columns={columns}
            rowClasses={TRClasses}
            noDataIndication="No Data Found"
            classes={TableClasses}
            wrapperClasses={TableWrapClasses}
          />
        </div>
      </div>
    </>
  );
};

export default ExpandConditions;
